export default __webpack_public_path__ + "275afe8.png";